<template>
  <NuxtLoadingIndicator :color="isLowerGrade ? '#5c5fb9' : '#F97954'" :height="4" />

  <EnvironmentOverlay />
  <UiGlobalNotifications />

  <NuxtLayout>
    <main id="jump-contend-start" class="flex flex-1 flex-col overflow-hidden @container/main max-lg:py-8">
      <NuxtPage />
    </main>
  </NuxtLayout>
</template>

<script lang="ts" setup>
document.body.classList.add(useIsTouchDevice() ? 'is-touch' : 'no-touch')

const config = useRuntimeConfig()
if (config.public.APP_URL !== window.location.origin) {
  alert('You are on the wrong domain!')
}

const auth = useAuthStore()
const cms = useCmsStore()
const route = useRoute()
const router = useRouter()

await Promise.all([auth.init(), cms.fetch()])

if (auth.user && ['Login', 'Index'].includes(route.name as string)) {
  await router.push(auth.homepage)
}
// redirect to login if not on a public page and live preview
if (
  !auth.user
  && !['Login', 'Public'].includes(route.name as string)
  && !route.query.token
) {
  await router.push({ name: 'Login' })
}

const { isLowerGrade } = useStudentSchoolYears(auth?.student)
const themeColor = computed(() => {
  return isLowerGrade.value ? '#FC8563' : '#5c5fb9'
})

useHead({
  titleTemplate: (title) => {
    return title ? `${title} – LernWege` : 'LernWege'
  },
  title: '', // set via template
  meta: [
    {
      name: 'theme-color',
      content: themeColor,
    },
  ],
})
</script>
